import { applyDataTestId } from "@/utils/testUtils";
import pom from "@/utils/pom";

export const ProfileIcon = () => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        data-testid={applyDataTestId(pom.icons.accountIcon)}
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>Profile</title>
        <path
          d="M15.5304 17.1008C14.8058 16.3716 13.9441 15.7929 12.995 15.3981C12.0458 15.0032 11.028 14.7999 10 14.7999C8.972 14.7999 7.95415 15.0032 7.00502 15.3981C6.05589 15.7929 5.19422 16.3716 4.4696 17.1008M14.2 8.2C14.2 10.5196 12.3196 12.4 10 12.4C7.6804 12.4 5.8 10.5196 5.8 8.2C5.8 5.8804 7.6804 4 10 4C12.3196 4 14.2 5.8804 14.2 8.2ZM19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z"
          stroke="#5D5D5D"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
